import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0 align-items-center" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "collapse show" }
const _hoisted_9 = { class: "card-body border-top p-9" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_12 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_14 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_21 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_22 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_23 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle-fill text-muted ms-1" }, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_32 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_33 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_40 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_41 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_42 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "row mb-6" }
const _hoisted_48 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_49 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_50 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_51 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "row mb-6" }
const _hoisted_57 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_58 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_59 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_60 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { class: "row mb-6" }
const _hoisted_66 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle-fill text-muted ms-1" }, null, -1)
const _hoisted_68 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_69 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_70 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_OrganismoDetalleServicios = _resolveComponent("OrganismoDetalleServicios")!
  const _component_OrganismoDatosIndividuales = _resolveComponent("OrganismoDatosIndividuales")!
  const _component_OrganismoProyectosN2 = _resolveComponent("OrganismoProyectosN2")!
  const _component_OrganismoDatosGestion = _resolveComponent("OrganismoDatosGestion")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Page, { showBack: "" }, {
    actions: _withCtx(() => [
      (!_ctx.creandoOrganismo)
        ? (_openBlock(), _createBlock(_component_el_dropdown, {
            key: 0,
            class: "mx-3"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, { onClick: _ctx.eliminar }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.eliminar")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, { type: "default" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_arrow_down)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
        type: "border-card",
        modelValue: "datosOrganismo"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            name: "datosOrganismo",
            label: _ctx.$t('formularios.organismo.tabs.general')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formularios.organismo.labelInfo")), 1)
                  ]),
                  (!_ctx.editingInfoOrganismo && !_ctx.creandoOrganismo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editingInfoOrganismo = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.editar.button")), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : (_ctx.creandoOrganismo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.crearOrganismo,
                            loading: _ctx.guardaDetalle
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.crear.button")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick", "loading"]),
                          _createVNode(_component_el_button, {
                            onClick: _ctx.$router.back
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.cancelar.button")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.guardarOrganismo,
                            loading: _ctx.guardaDetalle
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.guardar.button")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick", "loading"]),
                          _createVNode(_component_el_button, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editingInfoOrganismo = false))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.cancelar.button")), 1)
                            ]),
                            _: 1
                          })
                        ]))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("formularios.organismoDetalle.nombre.label")), 1),
                      (!_ctx.editingInfoOrganismo && !_ctx.creandoOrganismo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.nombre ?? "-"), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  name: "nombre",
                                  placeholder: " ",
                                  modelValue: _ctx.nombre,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nombre) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_ErrorMessage, { name: "nombre" })
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("formularios.organismoDetalle.tipoOrganismo.label")), 1),
                      (!_ctx.editingInfoOrganismo && !_ctx.creandoOrganismo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.tipoOrganizacion ?? "-"), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_el_select, {
                                  name: "tipoOrganizacion",
                                  class: "w-100",
                                  modelValue: _ctx.tipoOrganizacion,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tipoOrganizacion) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listadoTiposOrganizaciones, (tipoOrg, i) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: i,
                                        label: tipoOrg.nombre,
                                        value: tipoOrg.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createVNode(_component_ErrorMessage, { name: "tipoOrganizacion" })
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, [
                        _createTextVNode(_toDisplayString(_ctx.$t(
                      "formularios.organismoDetalle.esUbicacionGeografica.label"
                    )) + " ", 1),
                        _createVNode(_component_el_tooltip, {
                          class: "me-1",
                          content: 
                      _ctx.$t(
                        'formularios.organismoDetalle.esUbicacionGeografica.tooltip'
                      )
                    
                        }, {
                          default: _withCtx(() => [
                            _hoisted_30
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      (!_ctx.editingInfoOrganismo && !_ctx.creandoOrganismo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("label", _hoisted_32, [
                              _createVNode(_component_el_switch, {
                                disabled: "",
                                class: "ml-2",
                                modelValue: _ctx.esUbicacionGeografica,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.esUbicacionGeografica) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createVNode(_component_el_switch, {
                                  modelValue: _ctx.esUbicacionGeografica,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.esUbicacionGeografica) = $event)),
                                  name: "esUbicacionGeografica",
                                  class: "ml-2 mt-2"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createVNode(_component_ErrorMessage, { name: "esUbicacionGeografica" })
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("formularios.organismoDetalle.telefono.label")), 1),
                      (!_ctx.editingInfoOrganismo && !_ctx.creandoOrganismo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.telefono ?? "-"), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  name: "telefono",
                                  placeholder: " ",
                                  modelValue: _ctx.telefono,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.telefono) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _createVNode(_component_ErrorMessage, { name: "telefono" })
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("formularios.organismoDetalle.direccion.label")), 1),
                      (!_ctx.editingInfoOrganismo && !_ctx.creandoOrganismo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.direccion ?? "-"), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  name: "direccion",
                                  placeholder: " ",
                                  modelValue: _ctx.direccion,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.direccion) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createVNode(_component_ErrorMessage, { name: "direccion" })
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("formularios.organismoDetalle.notificaciones.familias")), 1),
                      (!_ctx.editingInfoOrganismo && !_ctx.creandoOrganismo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.email ?? "-"), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  name: "email",
                                  placeholder: " ",
                                  modelValue: _ctx.email,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.email) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("div", _hoisted_64, [
                                    _createVNode(_component_ErrorMessage, { name: "email" })
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("label", _hoisted_66, [
                        _createTextVNode(_toDisplayString(_ctx.$t(
                      "formularios.organismoDetalle.notificaciones.profesionales"
                    )) + " ", 1),
                        _createVNode(_component_el_tooltip, {
                          class: "me-1",
                          content: 
                      _ctx.$t('formularios.organismoDetalle.notificaciones.tooltip')
                    
                        }, {
                          default: _withCtx(() => [
                            _hoisted_67
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      (!_ctx.editingInfoOrganismo && !_ctx.creandoOrganismo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.emailProfesionales ?? "-"), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  name: "emailProfesionales",
                                  placeholder: " ",
                                  modelValue: _ctx.emailProfesionales,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.emailProfesionales) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_73, [
                                  _createElementVNode("div", _hoisted_74, [
                                    _createVNode(_component_ErrorMessage, { name: "emailProfesionales" })
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ])
                  ])
                ])
              ]),
              _hoisted_75
            ]),
            _: 1
          }, 8, ["label"]),
          (!_ctx.creandoOrganismo)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: _ctx.$t('formularios.organismo.tabs.colectivo'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_OrganismoDetalleServicios)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (!_ctx.creandoOrganismo)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 1,
                label: _ctx.$t('formularios.organismo.tabs.individual'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_OrganismoDatosIndividuales)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (!_ctx.creandoOrganismo)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 2,
                label: _ctx.$t('formularios.organismo.tabs.proyectosN2'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_OrganismoProyectosN2)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (!_ctx.creandoOrganismo)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 3,
                label: _ctx.$t('formularios.organismo.tabs.gestion'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_OrganismoDatosGestion)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.cargaDetalle]
      ])
    ]),
    _: 1
  }))
}